import { useTitleGenerationStreaming } from '@confluence/editor-features/entry-points/useTitleGenerationStreaming.ts';

export const LivePagesTitleAIGenerationOnPaste = ({
	contentId,
	cloudId,
	locale,
	documentContext,
	onTitleChange,
}: {
	contentId: string;
	cloudId: string;
	documentContext: string;
	locale: string;
	onTitleChange: (newTitle: string) => void;
}) => {
	useTitleGenerationStreaming({
		contentId,
		cloudId,
		documentContext,
		locale,
		skip: false,
		onTitleChange,
	});

	return null;
};
